export default __webpack_public_path__ + "static/media/blocked.1bac45a6.png";